export default __webpack_public_path__ + "static/media/propiedad-lujo.55626994.jpg";